// extracted by mini-css-extract-plugin
export var bands = "items-module--bands--kPBbB";
export var center = "items-module--center--N7t+8";